import { createSlice } from "@reduxjs/toolkit";
import { getCaseCredits } from "@custom/rtk-apis/Setting/creditForCaseToCase/getCaseCredits";

const initialState = {
  status: "",
  result: [],
  fullDoc: null,
  msg: "",
  loading: false,
  error: ""
};

const getCaseCreditsSlice = createSlice({
  name: "getCaseCreditsSlice",
  initialState,
  reducers: {
    clearGetCaseCreditsState: (state) => {
      state.status = '';
      state.result = [];
      state.fullDoc = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCaseCredits.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCaseCredits.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.caseCredits;
        state.fullDoc = payload.fullDoc;
        state.msg = payload.msg;
      })
      .addCase(getCaseCredits.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
        state.status = "FAILED";
      });
  }
});

export default getCaseCreditsSlice.reducer;
export const { clearGetCaseCreditsState } = getCaseCreditsSlice.actions;
